// extracted by mini-css-extract-plugin
export var box = "_7m-1";
export var checkboxRow = "_7m-8";
export var checked = "_7m-2";
export var descriptionSpacer = "_7m-a";
export var disabled = "_7m-3";
export var icon = "_7m-6";
export var input = "_7m-0";
export var labelSpacer = "_7m-9";
export var medium = "_7m-5";
export var small = "_7m-4";
export var text = "_7m-7";